<template>
  <div>
    <div class="bxTjzbhxr" v-if="kbxmlc.zt=='2'">
    <div class="box noBtn">
      <div class="main">

        <table-tem
          ref="table"
          :config="tableConfig"
          :key="tableConfig.key"
          :span-method="objectSpanMethod"
          :highlightCurrentRow="false"
          @changePage="tableChangePage"
          @changePages="changePages"
        >
          <template #tjzbhxr="scope">
              {{ scope.data.winningCandidate == 1 ? "中标候选人" : "" }}
          </template>
        </table-tem>
        <!-- <span class="lf pageNum">此次共有{{zgs}}家投标单位，递交投标报价{{}}家</span> -->
      </div>
    </div>
  </div>
  <div v-else class="loading">
    <p>正在抽取并审查中标候选人中，请耐心等待</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
  </div>


</template>

    <script>
import tableTem from "@/components/tableTem/index.vue";
export default {
  components: {
    tableTem,
  },
  props: {
    djlcId: {
      type: String,
      default: "",
    },
  },
  computed: {
    role() {
      return localStorage.getItem("role") ? localStorage.getItem("role") : "T";
    },
    isNext() {
      return this.kbxmlc.zt == 2;
    },
  },
  data() {
    return {
      waitLoading: false,

      tbdwmc: "",
      kbxmlc: {},
      tableConfig: {
        head: [],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
        height: 470,
        key: 1
      },

      tjzbhxr: null,
      tableData: [],
      number: [],
      dialogVisible: false,
      candidate: null,
    };
  },
  created() {
    this.tjzbhxr = 1;
    this.$nextTick(() => {
      this.getData();
    });
  },
  methods: {
    openHxr() {
      this.$confirm(
        "确定公布中标候选人?公布后投标单位可查看中标情况",
        "公布中标候选人",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            let res = await this.$api.publishCandidate();
            if (res.data.success) {
              this.$message.success("已公布中标候选人");
            } else {
              this.$message.error(res.data.msg);
            }
          } catch (err) {
            console.log(err);
          }
        })
        .catch(() => {});
    },
    async saveWinningCandidate(data, row) {
      try {
        let para = {
          jgdm: row.entCode,
          zbzt: data,
        };
        this.waitLoading = true;
        let res = await this.$api.saveCandidate(para);
        if (res.status == 200) {
          this.getWinningCandidateFlag();
          this.getData();
        } else {
          this.$message({ type: "error", message: res.message });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    draw() {
      window.open(`/tjzbhxrDraw?len=${this.tableData.length}`, "_blank");
    },
    changeData(secondaryName, threeLevelName) {
      this.tableConfig.data = [];
      this.number = [];
      this.companyFlag = false;
      for (const v of this.tableData) {
        v[secondaryName].map((k, index) => {
          k[threeLevelName].map((p, index) => {
            k[p.bjcsId] = p.csznr;
          });
        });
      }
      for (const v of this.tableData) {
        v[secondaryName].map((k, index) => {
          let param = {
            ...v,
            qdmc: this.tjzbhxr == 1 ? k.qdmc : v.qdmc,
            qymc: this.tjzbhxr == 1 ? v.qymc : k.qymc,
            ...k,
          };
          this.tableConfig.data.push(param);
        });
      }
      for (let i = 0; i < this.tableData.length; i++) {
        this.number.push({
          qdmc: this.tableData[i].qdmc,
          num: this.tableData[i][secondaryName].length,
        });
      }
      let msgIndex = 0;
      let msgArr = [];
      for (let i = 0; i < this.number.length; i++) {
        let num = this.number[i].num;
        msgIndex += num;
        msgArr.push(msgIndex);
      }
      msgArr.pop();
      msgArr.unshift(0);
      for (let i = 0; i < this.number.length; i++) {
        let num = this.number[i].num;
        this.tableConfig.data[msgArr[i]].rowspan = num;
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 如果是前两列，就使用idIndex数据来进行合并
      if (this.tjzbhxr == 1) {
        if ([0, 1, 2].includes(columnIndex) || column.label == "抽签编号" || column.label == "推荐中标候选人") {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
      } else {
        if (columnIndex <= 2) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
      }
    },
    tjzbhxrChange(index) {
      this.tjzbhxr = index;
      this.$refs.table.$refs.tableTem.clearSelection();
      this.getData();
    },
    getData(data) {
      this.once();
      this.candidate = null;
      let para = {
        djlcId: this.djlcId,
        currentPage: this.tableConfig.currentPage,
        type: this.tjzbhxr,
        pageSize: this.tableConfig.pageSize,
      };
      para = Object.assign(para, data);
      this.waitLoading = true;
      this.$api
        .kbzbhxrList(para)
        .then((res) => {
          if (res.data.meta.success) {
            let cgTbbjCsList = res.data.data.cgTbbjCsList || [];
            cgTbbjCsList.map((item, index) => {
              this.tableConfig.head.splice(3 + index, 0, {
                key: item.id,
                title:
                  item.cszmc + (item.bjlxdw ? "(" + item.bjlxdw + ")" : ""),
                align: "center",
              });
            });
            res.data.data.tbdwList.list.forEach((item, index) => {
              item.indexNum = this.tableConfig.pageSize * (this.tableConfig.currentPage - 1) + index + 1;
            });
            this.tableData = res.data.data.tbdwList.list;
            this.tableConfig.total = res.data.data.tbdwList.total;
            this.kbxmlc = res.data.data.kbxmlc;
            this.tableConfig.key++
            this.changeData("tbdwQdTbdwResultList", "tbdwCsTbdwResultList");
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    once() {
      this.tableConfig.head = [
        {
          type: "selection",
          width: 40,
        },
        {
          key: "indexNum",
          title: "序号",
          align: "center",
          width: 60,
        },
        {
          key: "qymc",
          title: "投标单位名称",
          align: "center",
        },
        {
          key: "pm",
          title: "抽签编号",
          align: "center",
        },
        {
          type: "slot",
          title: "推荐中标候选人",
          align: "center",
          slotName: "tjzbhxr",
        },
      ];
    },
    dialogShow() {
      const list = this.$refs.table.checkList;
      if (list.length == 1) {
        this.dialogVisible = true;
      } else {
        this.$message.warning("请勾选1家投标单位");
      }
    },
    bxNextBtn() {
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.waitLoading = true;
      this.$emit("nextBtn", para);
    },
    // 分页功能
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
  },
};
</script>

    <style lang='scss' scoped>
.noBtn {
  display: flex;
  flex-direction: column;
}
.main {
  .main-top {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    .main-top-left {
      margin-bottom: 10px;
      label {
        margin-right: 20px;
      }
    }
  }
  .rightButton {
    position: absolute;
    right: 10px;
    top: 60px;
  }
}
.clear {
  clear: initial !important;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pageNum {
  position: relative;
  bottom: 50px;
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: white;
}
</style>
